import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { Currency, CurrencyRate } from 'src/app/shared/currency'
import { ProductApiService } from 'src/app/services/product-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

/**
 * Generic modal dialog for renaming any entity.
 *
 * The caller binds `[(textToRename)]` to a string field; the dialog renders
 * a labelled text input and a confirm button.  On confirm, `onRename` emits
 * the current value of `textToRename`.  `displayChange` emits `false` on hide
 * to support two-way `[(display)]` binding.
 *
 * `canConfirm` guards the button — confirm is only enabled when `textToRename`
 * is non-empty.  `doConfirm` handles the Enter-key shortcut.
 */
@Component({
  selector: 'app-rename-something-dialog',
  templateUrl: './rename-something-dialog.component.html',
  styleUrls: ['./rename-something-dialog.component.css']
})
export class RenameSomethingDialogComponent implements OnInit, OnChanges, OnDestroy {

  /** Controls dialog visibility; supports two-way binding via `displayChange`. */
  @Input() display: boolean = false;

  /** Text shown in the dialog title bar. */
  @Input() header: string = 'Подтвердите удаление...';

  /** The current text value bound to the rename input field (v-model equivalent). */
  @Input() textToRename: string = '';

  /** Label displayed above the text input. */
  @Input() inputLabel: string = 'Введите новое имя';

  /** Emits `false` on dialog hide to support two-way `[(display)]` binding. */
  @Output() displayChange = new EventEmitter();

  /** Emits the new name string when the user confirms. */
  @Output() onRename = new EventEmitter<string>();

  modal: boolean = true;

  /** True when `textToRename` is non-empty; gates the confirm button. */
  public get canConfirm(): boolean { return (this.textToRename || '').length > 0; }

  settings: GlobalSettingsData;

  constructor() {}

  /** No subscriptions to clean up. */
  ngOnDestroy() {
  }

  /** No-op — reacts to input changes but no action needed for current inputs. */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** RenameSomethingDialogComponent ngOnChanges: ');
    for (let propName in changes) {
      let change = changes[propName];

      //console.log('*** RenameSomethingDialogComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));
      console.log('*** RenameSomethingDialogComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'parentCompany':
          break;
      }
    }
  }

  /** No-op initialisation. */
  ngOnInit(): void {
    console.log('*** RenameSomethingDialogComponent onInit');
  }

  /** No-op — called by PrimeNG dialog `(onShow)`. */
  onShowDialog() {
    console.log('*** RenameSomethingDialogComponent onShow: ');
  }

  /** Emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    console.log('*** RenameSomethingDialogComponent onHide');
    this.displayChange.emit(false);
  }

  /** Enter-key shortcut — delegates to `onConfirm` when `canConfirm` is true. */
  doConfirm(event) {
    console.log('*** RenameSomethingDialogComponent doConfirm: ' + JSON.stringify(event));
    if (this.canConfirm) this.onConfirm('enter');
  }

  /** Emits `textToRename` via `onRename` and closes the dialog. */
  onConfirm(text: string) {
    console.log('*** RenameSomethingDialogComponent onConfirm: ' + text);
    if (this.canConfirm) {
      this.onRename.emit(this.textToRename);
      this.display = false;
    }
  }

}
